import React from "react";
import { Box, Typography, Button, Card } from "@mui/material";
import { useNavigate } from "react-router-dom";

const SuccessMessage: React.FC = () => {
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate("/login");
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          padding: 3,
        }}
      >
        <Card variant="outlined">
          <Typography variant="h4" color="primary" gutterBottom>
            ¡Datos enviados correctamente!
          </Typography>
          <Typography variant="body1" color="textSecondary" paragraph>
            Gracias por confiar en nosotros. El proceso ha sido completado con
            éxito.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={handleRedirect}
            sx={{ marginTop: 2 }}
          >
            Volver al panel
          </Button>
        </Card>
      </Box>
    </Box>
  );
};

export default SuccessMessage;
